import Vue from 'vue';
import { EmailShare } from "@wenjuan/business";
Vue.component("EmailShare", EmailShare);